import React from "react";
import { Counterparty } from "../../../common/types/counterparty";
import styles from "./RuleCategoryAction.module.scss";

interface Props {
    value: string;
    counterparties: Counterparty[];
}

export const RuleCounterpartyAction: React.FC<Props> = ({
    value,
    counterparties,
}) => {
    const counterparty = counterparties.find((c) => c.id === value);

    if (!counterparty) {
        return null;
    }

    return (
        <div>
            Update Vendor/Customer to{" "}
            <span className={styles.category}>
                <strong>{counterparty.name}</strong>
            </span>
        </div>
    );
};
